module.exports = __webpack_public_path__ + "img/lvdou.7d9a3a3b.png";